export default {
  TRELLO_AUTHORIZED(state, auth) {
    state.trello.authorized = auth;
  },

  TRELLO_AUTH_DATE(state, date) {
    state.trello.auth_date = date;
  },
};
